import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {doLogin, THEME_TYPE_LIGHT, useApplicationContext} from "../../../context/ApplicationContextProvider";
import {useDialogContext} from "../../../context/DialogContextProvider";
import {useMountEffect} from "../../../utils/Hooks";
import {FOOTER_TYPE_BASE} from "../section/Footer";
import {HEADER_LOGO_TYPE_BASE, HEADER_TYPE_BASE} from "../section/Header";
import {account_actions} from "../../../redux/slice/AccountReducer";
import {cache_actions} from "../../../redux/slice/CacheReducer";
import {lang} from "../../../lang/index";
import {storage_get} from "../../../common";
import Seo from '../../main/component/Seo';

export const PERMISSION_ALL = 1;
export const PERMISSION_SESSION = 2;

// props.permission = {PERMISSION_ALL|PERMISSION_SESSION}
// props.title seo
// props.description seo
// props.keywords, string seo
const RouteComponent = (props) => {
    const application_context = useApplicationContext();
    const permission = props.permission;

    useMountEffect(() => {
        application_context.ui._initialize({
            theme: THEME_TYPE_LIGHT,
            header: {
                type: HEADER_TYPE_BASE,
                logo_type: HEADER_LOGO_TYPE_BASE,
                with_spacing: true,
                with_sticky: true,
            },
            footer: {
                type: FOOTER_TYPE_BASE,
            },
        });
    }, [application_context]);

    // const has_valid_session = useState(false);
    const [can_render, setRender] = useState(false);

    const {alert} = useDialogContext();
    const account_reducer = useSelector((state) => state.account_reducer);
    const dispatch = useDispatch();
    const location = useLocation();

    const doRequireLogin = async (message) => {
        await alert(message);
        doLogin(location.pathname);
    };

    // return bool, is_session_validated
    const checkSession = async () => {
        let is_session_validated = false;
        if (account_reducer.is_login) {
            // 로그인 되있음
            // 로컬 로그인 세션값을 확인한다
            let access_token = account_reducer.token; // 401 처리를 인터셉터 하지 않도록 설정함
            if (access_token) {
                is_session_validated = true;
                // @TODO update refreshed token
            } else {
                let message = lang.login.require_login_confirm;
                // logout, 로그인과 관련된 store 를 비운다
                dispatch(account_actions.doLogout());
                dispatch(cache_actions.removeAll());
                if (permission === PERMISSION_SESSION) {
                    // 해당 페이지가 세션이 필요한 경우, 로그인 유도
                    doRequireLogin(message);
                }
            }
        } else if (storage_get("auth_info")) {
            // 리덕스 값은 없지만 로그인 상태 유지 체크로 local storage에 저장된 정보가 있다면 dispatch 한 뒤 is_session_validate = true
            const auth_info = storage_get("auth_info");
            let tmp = {
                info: auth_info.account,
                token: auth_info.login_token,
                with_detail_info: false,
                company: auth_info.company,
            };

            dispatch(account_actions.doLogin(tmp));

            is_session_validated = true;
        } else {
            // 로그인 안되있음
            if (permission === PERMISSION_SESSION) {
                // 해당 페이지가 세션이 필요한 경우, 로그인 유도
                doRequireLogin(lang.login.require_login_confirm);
            }
        }

        return is_session_validated;
    };

    const doCheck = async () => {
        let do_can_render = false;
        if (permission === PERMISSION_SESSION) {
            // 권한이 필요한 페이지면 세션을 확인
            let is_session_validated = await checkSession();
            if (is_session_validated) {
                do_can_render = true;
            }
        } else {
            do_can_render = true;
        }

        setRender(do_can_render);
    };

    useMountEffect(() => {
        setTimeout(() => {
            // 페이지 이동시 상단으로 이동
            window.scrollTo(0, 0);
        }, 50);
        doCheck();
    });

    return (
      <>
          <Seo
            title={props.title}
            description={props.description}
          ></Seo>
          {can_render && <props.component {...props} />}
      </>
    );
};

export default RouteComponent;
